<template>
	<div class="row mx align-items-center">
<!--		<div>-->
<!--			<img :src="iconSrc" width="50px">-->

<!--		</div>-->
		<div class="col">
			<div><strong>{{paymentIntegrationItem.paymentMethodFormatted()}}</strong></div>
			<div v-if="paymentIntegrationItem.description">{{paymentIntegrationItem.description}}</div>
		</div>
<!--		<div >-->
<!--			<el-button v-if="isButtonVisible" @click="onButtonClickedHandler" size="small" plain type="primary">{{buttonTitle}}</el-button>-->
<!--			<div v-else>{{buttonTitle}}</div>-->
<!--		</div>-->

	</div>
</template>

<script>
    import PaymentIntegrationItem from "@shared/Billing/PaymentIntegrationItem";

	export default {
        name: "AvailablePaymentMethodRow",
		props:{
			paymentIntegrationItem: PaymentIntegrationItem,
			iconSrc:String
		}
    }
</script>

<style>

</style>
